import api from "@/api/co.api";
import web from "@/api/web/co.web";
import dayjs from "dayjs";

import mixPreset from "@/pages/mixins/activity/mix.exhibit.preset";

const parts = mixPreset.Parts;
const names = mixPreset.Names;

export default {
  data () {
    return {
      currDate: "",
      currTab: names.PROCESSED,
      tabList: [
        // parts[names.PROCESSING],
        parts[names.PROCESSED],
        parts[names.NATIONAL]
      ],
      curPage: 1,
      pag: {
        current: 1,
        length: 1
      },
      tab: parts[names.NATIONAL]
    };
  },
  created () {
    this.currDate = dayjs().format("YYYY-MM-DD");
    const pt0 = this.tabList[0];

    pt0.doingDate = "";
    pt0.finishDate = this.currDate;
  },
  methods: {
    changePagination (number, cat) {
      const params = cat.params;
      const data = cat.params.data;
      const index = parseInt(number, 10) || 1;

      cat.pagination.current = index;
      data.pageNum = index;
      params.reload = true;
      api.httpx.getItems(params);
    },
    onContent (ev, navigation) {
      const item = ev.item;

      if (navigation.state == "roadShow") {
        if (item.unlink) {
          window.open(item.unlink);
        } else {
          this.$router.push({
            path: "national",
            query: {
              id: item.roadshowId
            }
          });
        }
      } else {
        this.toContent(item, navigation);
      }
    },
    toContent (item, navigation) {
      const params = {
        activityId: item.activityId
        // title: item.title,
        // name: navigation.name,
      };
      api.page.navigateBy(this, "exhibitDetail", params);
    },
    configContent (obj) {
      const executed = function (res) {
        const data = obj.params.data;
        const pagination = obj.pagination;
        const pageSize = parseInt(data.pageSize) || 9;
        pagination.length = Math.ceil(res.total / pageSize);
      };

      if (obj.name == "processed") {
        obj.params = web.activity.getParams({
          state: obj.state,
          doingDate: obj.doingDate,
          finishDate: obj.finishDate,
          sort: "num_sort",
          order: "asc",
          caches: obj.items,
          title: "大展",
          type: "",
          executed
        });
      } else {
        obj.params = web.activity.getParamsRoad({
          num: "",
          address: "",
          title: "",
          caches: obj.items,
          executed
        });
      }
    },
    configContents () {
      for (const i in this.tabList) {
        const item = this.tabList[i];
        this.configContent(item);
      }
    },
    loadContents (reload = true) {
      for (const i in this.tabList) {
        const item = this.tabList[i];
        item.params.reload = reload;
        api.httpx.getItems(item.params);
      }
    }
  }
};
